import { getCurrentInstance } from "vue";
export function useRoute() {
    const instance = getCurrentInstance();
    const proxy = instance?.proxy;
    return proxy.$route;
}
